import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, Box, IconButton } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import STERISLogoPng from '../styles/img/STERIS-Logo.png';
import connectassurePng from '../styles/img/connectassure.png';
import { logout } from '../common/auth';

const TopHeader = () => {


	return (
		<Box className="no-print">
			<Box>
				<AppBar position="fixed" sx={{ background: '#205080', zIndex: 10000 }}>
					<Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<img src={connectassurePng} alt="Connect Assure Logo" />
							<br />
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<img
								className="center-block img-responsive"
								style={{
									padding: '0em .7em',
									borderRadius: '.3em',
									background: 'white',
									maxHeight: '3.8em'
								}}
								src={STERISLogoPng}
								alt="Hospital or STERIS Logo"
							/>
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center' }} component="form" autoComplete="off" onSubmit={(e) => e.preventDefault()}>
							<IconButton
								className="no-print"
								title="LogOut"
								onClick={async () => await logout()}
								sx={{ color: 'background.paper' }}
							>
								<LogoutIcon fontSize="inherit" />
							</IconButton>
						</Box>
					</Toolbar>
				</AppBar>
				<Box sx={{ height: 40 }}></Box>
			</Box>
		</Box>
	);
};



export default TopHeader;
